<template>
  <v-container fluid fill-height justify-center id="scrolling-techniques-7" class="overflow-y-auto" key="register">
    <transition name="router-anim" mode="out-in">
      <v-row v-if="success" key="1" class="max-w">
        <v-col class="px-7">
          <div class="display-1 font-weight-medium mb-4">
            {{ $t('konto-utw-tytul') }}
          </div>
          <div class="mb-5 c-lighter-1">
            {{ $t('konto-utw-podtytul') }}<br />
            {{ $t('konto-utw-opis') }}
          </div>
          <v-btn x-large class="btn-secondary" to="/">Powrót</v-btn>
        </v-col>
      </v-row>
      <v-row v-else key="2" class="max-w">
        <v-col>
          <v-form
            ref="form"
            v-model="valid"
            class="px-5"
          >
            <div class="display-1 font-weight-medium mb-3">
              {{ $t('nowe-konto') }}
            </div>
            <div class="font-weight-light mb-6 c-lighter-1">
              {{ $t('motto-1') }}
            </div>

            <v-text-field
            v-model="email"
            :rules="emailRules"
            label="E-mail"
            required
            ></v-text-field>

            <v-text-field
            v-model="password"
            :counter="8"
            :rules="passwordRules"
            :label="$t('haslo')"
            required
            type="password"></v-text-field>

            <v-text-field
            v-model="password2"
            :counter="8"
            :rules="password2Rules"
            :label="$t('haslo-powt')"
            required
            type="password"></v-text-field>
            
            <div class="text-center mt-8">
              <v-btn 
              :loading="saving"
              :disabled="saving" 
              @click="postForm"
              x-large class="w-100" color="primary">{{ $t('utworz') }}</v-btn>
            </div>

          </v-form>
        </v-col>
      </v-row>
    </transition>

  </v-container>
</template>

<script>
  export default {
    data: () => ({
      valid: true,
      email: '',
      emailRules: [
        v => !!v || 'Wypełnij E-mail',
        v => /.+@.+/.test(v) || 'E-mail jest nieprawidłowy'
      ],
      password: '',
      passwordRules: [
        v => !!v || 'Wypełnij hasło',
        v => (v && v.length >= 6) || 'Hasło musi mieć minimum 6 znaków'
      ],
      password2: '',
      password2Rules: [
        v => !!v || 'Wypełnij hasło',
        //v => (v && v.length >= 6) || 'Hasło musi mieć minimum 6 znaków'
      ],
      saving: false,
      snackbar: false,
      snackbarText: '',
      snackbarColor: "error",
      success: false
    }),

    methods: {
      validate () {
        if (this.$refs.form.validate()) {
          this.snackbar = true
        }
      },
      resetValidation () {
        this.$refs.form.resetValidation()
      },
      postForm () {
        const formData = new URLSearchParams();
        formData.append('email', this.email);
        formData.append('password', this.password);
        formData.append('password2', this.password2);

        this.$store.dispatch('signup', formData)
        .then(res => {
          this.saving = false;
          if (res.error) {
            this.$store.commit("alert", {
              color: "error",
              text: res.error.code
            });
          } else {
            this.success = true;
          }
        });
      }
    }
  }
</script>

<style>
</style>

